import {
  Avatar,
  Box,
  CustomTheme,
  lighten,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import { Menu } from './components/Menu';
import { useAuth } from '../../../../context/AuthProvider';

export const BottomMenu: React.FC = (): JSX.Element | null => {
  const theme = useTheme<CustomTheme>();
  const { auth } = useAuth();

  const currentUser = auth?.user;

  const [userMenuAnchorElement, setUserMenuAnchorElement] =
    useState<HTMLElement | null>(null);

  const onUserButtonClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    setUserMenuAnchorElement(event.currentTarget);
  };

  const closeUserMenu = (): void => {
    setUserMenuAnchorElement(null);
  };

  if (!currentUser) {
    return null;
  }

  return (
    <Box>
      <Menu
        show={!!userMenuAnchorElement}
        anchorEl={userMenuAnchorElement}
        onClose={closeUserMenu}
      />

      <List>
        <ListItem disablePadding>
          <ListItemButton
            onClick={onUserButtonClick}
            sx={{
              p: 0,
              px: '10px',
              borderRadius: '5px',
              '&:hover': {
                backgroundColor: lighten(theme.portal.sidebar.background, 0.09),
              },
            }}
          >
            <ListItemAvatar
              sx={{
                minWidth: '45px',
              }}
            >
              <Avatar
                alt={currentUser.name}
                src={`${process.env.REACT_APP_API_URL}/agents/avatar/${currentUser.avatar}`}
                sx={{
                  width: '35px',
                  height: '35px',
                  bgcolor: (theme) => theme.palette.primary.main,
                }}
              />
            </ListItemAvatar>
            <ListItemText
              primary={currentUser.name}
              secondary={currentUser.email}
              primaryTypographyProps={{
                fontSize: 14,
                fontWeight: 'bold',
                color: lighten(theme.portal.sidebar.textColor, 0.5),
              }}
              secondaryTypographyProps={{
                color: theme.portal.sidebar.textColor,
              }}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );
};
